import React from 'react'
import RoomSchedule from 'frontend/schedule/room-schedule'
import PlayersCountButtons from 'frontend/schedule/players-count-buttons'
import PlayersCountInput from 'frontend/schedule/players-count-input'
import RoomWeekSelect from 'frontend/schedule/room-week-select'
import CommonIcons from 'frontend/components/common-icons'

export default class MrsJezebelSchedule extends RoomSchedule {
  renderFilters () {
    return (
      <div className="filters">
        <div className="select_players_count">
          <h4 className="title">
            <span className="fix_title">1. Select number of players</span>
          </h4>
          <PlayersCountButtons
            playersWithMinPrices={this.state.schedule.minPriceByPlayersCount}
            selected={this.state.selectedPlayersCount}
            onSelect={this.handlePlayersCountSelect.bind(this)}
          />
          <div className="players_count_input_with_price_indicator">
            <PlayersCountInput
              minPlayers={this.state.schedule.minPlayers}
              maxPlayers={this.state.schedule.maxPlayers}
              value={this.state.selectedPlayersCount}
              onChange={this.handlePlayersCountSelect.bind(this)}
            />
          </div>
        </div>
        <div className="select_date">
          <h4 className="title">
            <span className="fix_title">2. Select date and time</span>
          </h4>
          <RoomWeekSelect
            selected={this.state.selectedDate}
            onChange={this.handleDateSelect.bind(this)}
          />
        </div>
      </div>
    )
  }

  renderHelpers () {
    return (
      <div className="helpers">
        <div className="no_strangers_notice helper">
          <CommonIcons item="common-user-secret" className="icon" />
          *All games are private, only your team is allowed in the room, NO STRANGERS.
        </div>

        <div className="game_cost helper">
          <CommonIcons item="common-calendar-alt-r" className="icon" />
          <div className="label">Thursday - Sunday</div>
          <div className="value">starting&nbsp;at $46&nbsp;per/person</div>
        </div>
      </div>
    )
  }
}
